import { render, staticRenderFns } from "./crudTasks.vue?vue&type=template&id=6dbfc8a2&"
import script from "./crudTasks.vue?vue&type=script&lang=js&"
export * from "./crudTasks.vue?vue&type=script&lang=js&"
import style0 from "./crudTasks.vue?vue&type=style&index=0&id=6dbfc8a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports